import { motion } from "framer-motion";
import { Phone, MessageCircle } from "lucide-react";
import { TEL_LINK, WHATSAPP_URL } from "../lib/site";

const base =
  "inline-flex items-center justify-center gap-2.5 rounded-[10px] font-archivo font-bold tracking-tight transition-colors duration-300";

export const CallButton = ({ label = "Bel nu", testid, className = "px-7 py-4 text-base" }) => (
  <motion.a
    href={TEL_LINK}
    data-testid={testid}
    whileHover={{ scale: 1.04 }}
    whileTap={{ scale: 0.96 }}
    transition={{ type: "spring", stiffness: 400, damping: 22 }}
    className={`${base} bg-amber text-[#181510] hover:bg-amberdeep ${className}`}
  >
    <Phone size={18} strokeWidth={2.5} />
    {label}
  </motion.a>
);

export const WhatsAppButton = ({ label = "WhatsApp ons", testid, className = "px-7 py-4 text-base" }) => (
  <motion.a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid}
    whileHover={{ scale: 1.04 }}
    whileTap={{ scale: 0.96 }}
    transition={{ type: "spring", stiffness: 400, damping: 22 }}
    className={`${base} bg-wa text-white hover:bg-wadeep ${className}`}
  >
    <MessageCircle size={18} strokeWidth={2.5} />
    {label}
  </motion.a>
);
